export const preventiviSpec = [
    {
        "contrato": "cessione",
        "impiego": "pubblico",
        "convenzione": [
            {
                "codiceConvenzione": "INPS",
                "descrizioneConvenzione": "CONVENZIONE INPS 2020"
            },
            {
                "codiceConvenzione": "REG_SICILIANA",
                "descrizioneConvenzione": "REGIONE SICILIANA DIPENDENTI"
            },
            {
                "codiceConvenzione": "CQP REGIONE SIC",
                "descrizioneConvenzione": "PENSIONATI REGIONE SICILIA"
            },
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "ENASARCO",
                "descrizioneConvenzione": "ENASARCO"
            },
            {
                "codiceConvenzione": "FERSERVIZI",
                "descrizioneConvenzione": "FERSERVIZI"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "CASSAFORENSE",
                "descrizioneConvenzione": "CASSA FORENSE"
            }
        ]
    },
    {
        "contrato": "delega",
        "impiego": "pubblico",
        "convenzione": [
            {
                "codiceConvenzione": "REG_SICILIANA",
                "descrizioneConvenzione": "REGIONE SICILIANA DIPENDENTI"
            },
            {
                "codiceConvenzione": "FORESTAS",
                "descrizioneConvenzione": "FORESTAS AGENZIA FORESTALE REGIONALE"
            },
            {
                "codiceConvenzione": "ASP 7 RAGUSA",
                "descrizioneConvenzione": "ASP RAGUSA 7"
            },
            {
                "codiceConvenzione": "AZ OSP MESSINA",
                "descrizioneConvenzione": "AS. OSP MESSINA"
            },
            {
                "codiceConvenzione": "ASLFROSINONE",
                "descrizioneConvenzione": "AZIENDA UNITA' SANITARIA LOCALE FROSINONE"
            },
            {
                "codiceConvenzione": "COMUNECATANIA",
                "descrizioneConvenzione": "COMUNE DI CATANIA"
            },
            {
                "codiceConvenzione": "COMUNEPATERNO'",
                "descrizioneConvenzione": "COMUNE DI PATERNO'"
            },
            {
                "codiceConvenzione": "ASP POTENZA",
                "descrizioneConvenzione": "ASP POTENZA"
            },
            {
                "codiceConvenzione": "CON_BON_ALTOJON",
                "descrizioneConvenzione": "CONSORZIO DI BONIFICA ALTO JONIO REGGINO"
            },
            {
                "codiceConvenzione": "ASST_NIGUARDA",
                "descrizioneConvenzione": "ASST GRANDE OSPEDALE METROPOL NIGUARDA"
            },
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "UNIVMESSINA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DI MESSINA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "CITTA_MESSINA",
                "descrizioneConvenzione": "CITTA' METROPOLITANA MESSINA"
            },
            {
                "codiceConvenzione": "COMUNEACIREALE",
                "descrizioneConvenzione": "COMUNE DI ACIREALE"
            },
            {
                "codiceConvenzione": "CITTA_PALERMO",
                "descrizioneConvenzione": "CITTA' METROPOLITANA PALERMO"
            },
            {
                "codiceConvenzione": "CITTA_NAPOLI",
                "descrizioneConvenzione": "CITTA' METROPOLITANA DI NAPOLI"
            },
            {
                "codiceConvenzione": "COMUNE BARI",
                "descrizioneConvenzione": "COMUNE DI BARI"
            },
            {
                "codiceConvenzione": "ASP_PALERMO",
                "descrizioneConvenzione": "AZIENDA SANITARIA PROVINCIALE PALERMO"
            },
            {
                "codiceConvenzione": "OSP_VILLASOFIA",
                "descrizioneConvenzione": "AZ. OSP. OSPEDALI RIUNITI VILLA SOFIA"
            },
            {
                "codiceConvenzione": "AOU SASSARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA SASSARI"
            },
            {
                "codiceConvenzione": "AZOSPSANCARLO",
                "descrizioneConvenzione": "AZIENDA OSPEDALERIA REGIONALE SAN CARLO"
            },
            {
                "codiceConvenzione": "SANITASERVICELE",
                "descrizioneConvenzione": "SANITASERVICE ASL LE SRL"
            },
            {
                "codiceConvenzione": "LAORE_SARDEGNA",
                "descrizioneConvenzione": "LAORE SARDEGNA"
            },
            {
                "codiceConvenzione": "COMUNEOLBIA",
                "descrizioneConvenzione": "COMUNE DI OLBIA"
            },
            {
                "codiceConvenzione": "REGIONESARDEGNA",
                "descrizioneConvenzione": "REGIONE AUTONOMA SARDEGNA"
            },
            {
                "codiceConvenzione": "AZ OSP CAGLIARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA DI CAGLIARI"
            },
            {
                "codiceConvenzione": "UNIVTORVERGATA",
                "descrizioneConvenzione": "UNIVERSITA' TOR VERGATA ROMA"
            },
            {
                "codiceConvenzione": "AZOSPBROTZU",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA BROTZU"
            },
            {
                "codiceConvenzione": "AGRIS_SARDEGNA",
                "descrizioneConvenzione": "AGRIS SARDEGNA"
            },
            {
                "codiceConvenzione": "UNI_COMU_CONSEL",
                "descrizioneConvenzione": "UNIONE DEI COMUNI DEL CONSELVANO"
            },
            {
                "codiceConvenzione": "AREUS SARDEGNA",
                "descrizioneConvenzione": "AREUS SARDEGNA"
            },
            {
                "codiceConvenzione": "ASLAVEZSULMAQU",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE AVEZZANO SULMONA L'AQUILA"
            },
            {
                "codiceConvenzione": "REGIONEVENETO",
                "descrizioneConvenzione": "REGIONE DEL VENETO"
            },
            {
                "codiceConvenzione": "UNI_CHIETIEPESC",
                "descrizioneConvenzione": "UNIVERSITA' CHIETI E PESCARA"
            },
            {
                "codiceConvenzione": "COMUNE_META",
                "descrizioneConvenzione": "COMUNE DI META"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "COMUNEMONTESARC",
                "descrizioneConvenzione": "COMUNE DI MONTESARCHIO"
            },
            {
                "codiceConvenzione": "GRANDEOSPMETROP",
                "descrizioneConvenzione": "GRANDE OSPEDALE METROPOLITANO REGGIO CAL"
            },
            {
                "codiceConvenzione": "COMUNENISCEMI",
                "descrizioneConvenzione": "COMUNE DI NISCEMI"
            },
            {
                "codiceConvenzione": "ARES118",
                "descrizioneConvenzione": "ARES 118"
            },
            {
                "codiceConvenzione": "COMUNEREGCALABR",
                "descrizioneConvenzione": "COMUNE DI REGGIO CALABRIA"
            },
            {
                "codiceConvenzione": "ARNAS CATANIA",
                "descrizioneConvenzione": "ARNAS CATANIA"
            },
            {
                "codiceConvenzione": "UNIVBASILICATA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DELLA BASILICATA"
            },
            {
                "codiceConvenzione": "ASLTARANTO",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE DI TARANTO"
            },
            {
                "codiceConvenzione": "UNISIENA",
                "descrizioneConvenzione": "UNIVERSIT\u00c0 DEGLI STUDI DI SIENA"
            },
            {
                "codiceConvenzione": "SMACAMPANIA",
                "descrizioneConvenzione": "SMA CAMPANIA"
            }
        ]
    },
    {
        "contrato": "cessione",
        "impiego": "statale",
        "convenzione": [
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "ENASARCO",
                "descrizioneConvenzione": "ENASARCO"
            },
            {
                "codiceConvenzione": "FERSERVIZI",
                "descrizioneConvenzione": "FERSERVIZI"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "CASSAFORENSE",
                "descrizioneConvenzione": "CASSA FORENSE"
            }
        ]
    },
    {
        "contrato": "delega",
        "impiego": "statale",
        "convenzione": [
            {
                "codiceConvenzione": "NOIPA",
                "descrizioneConvenzione": "CONVENZIONE NOIPA DELEGHE STATALI"
            },
            {
                "codiceConvenzione": "AZ OSP MESSINA",
                "descrizioneConvenzione": "AS. OSP MESSINA"
            },
            {
                "codiceConvenzione": "ARMACARABINIERI",
                "descrizioneConvenzione": "ARMA DEI CARABINIERI"
            },
            {
                "codiceConvenzione": "ASLFROSINONE",
                "descrizioneConvenzione": "AZIENDA UNITA' SANITARIA LOCALE FROSINONE"
            },
            {
                "codiceConvenzione": "UNIVPALERMO",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DI PALERMO"
            },
            {
                "codiceConvenzione": "COMUNEPATERNO'",
                "descrizioneConvenzione": "COMUNE DI PATERNO'"
            },
            {
                "codiceConvenzione": "CON_BON_ALTOJON",
                "descrizioneConvenzione": "CONSORZIO DI BONIFICA ALTO JONIO REGGINO"
            },
            {
                "codiceConvenzione": "ASST_NIGUARDA",
                "descrizioneConvenzione": "ASST GRANDE OSPEDALE METROPOL NIGUARDA"
            },
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "UNIVMESSINA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DI MESSINA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "CITTA_MESSINA",
                "descrizioneConvenzione": "CITTA' METROPOLITANA MESSINA"
            },
            {
                "codiceConvenzione": "COMUNEACIREALE",
                "descrizioneConvenzione": "COMUNE DI ACIREALE"
            },
            {
                "codiceConvenzione": "CITTA_PALERMO",
                "descrizioneConvenzione": "CITTA' METROPOLITANA PALERMO"
            },
            {
                "codiceConvenzione": "CITTA_NAPOLI",
                "descrizioneConvenzione": "CITTA' METROPOLITANA DI NAPOLI"
            },
            {
                "codiceConvenzione": "COMUNE BARI",
                "descrizioneConvenzione": "COMUNE DI BARI"
            },
            {
                "codiceConvenzione": "ASP_PALERMO",
                "descrizioneConvenzione": "AZIENDA SANITARIA PROVINCIALE PALERMO"
            },
            {
                "codiceConvenzione": "OSP_VILLASOFIA",
                "descrizioneConvenzione": "AZ. OSP. OSPEDALI RIUNITI VILLA SOFIA"
            },
            {
                "codiceConvenzione": "AOU SASSARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA SASSARI"
            },
            {
                "codiceConvenzione": "AZOSPSANCARLO",
                "descrizioneConvenzione": "AZIENDA OSPEDALERIA REGIONALE SAN CARLO"
            },
            {
                "codiceConvenzione": "SANITASERVICELE",
                "descrizioneConvenzione": "SANITASERVICE ASL LE SRL"
            },
            {
                "codiceConvenzione": "LAORE_SARDEGNA",
                "descrizioneConvenzione": "LAORE SARDEGNA"
            },
            {
                "codiceConvenzione": "COMUNEOLBIA",
                "descrizioneConvenzione": "COMUNE DI OLBIA"
            },
            {
                "codiceConvenzione": "REGIONESARDEGNA",
                "descrizioneConvenzione": "REGIONE AUTONOMA SARDEGNA"
            },
            {
                "codiceConvenzione": "AZ OSP CAGLIARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA DI CAGLIARI"
            },
            {
                "codiceConvenzione": "UNIVTORVERGATA",
                "descrizioneConvenzione": "UNIVERSITA' TOR VERGATA ROMA"
            },
            {
                "codiceConvenzione": "AZOSPBROTZU",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA BROTZU"
            },
            {
                "codiceConvenzione": "AGRIS_SARDEGNA",
                "descrizioneConvenzione": "AGRIS SARDEGNA"
            },
            {
                "codiceConvenzione": "AREUS SARDEGNA",
                "descrizioneConvenzione": "AREUS SARDEGNA"
            },
            {
                "codiceConvenzione": "ASLAVEZSULMAQU",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE AVEZZANO SULMONA L'AQUILA"
            },
            {
                "codiceConvenzione": "REGIONEVENETO",
                "descrizioneConvenzione": "REGIONE DEL VENETO"
            },
            {
                "codiceConvenzione": "UNI_CHIETIEPESC",
                "descrizioneConvenzione": "UNIVERSITA' CHIETI E PESCARA"
            },
            {
                "codiceConvenzione": "COMUNE_META",
                "descrizioneConvenzione": "COMUNE DI META"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "COMUNEMONTESARC",
                "descrizioneConvenzione": "COMUNE DI MONTESARCHIO"
            },
            {
                "codiceConvenzione": "GRANDEOSPMETROP",
                "descrizioneConvenzione": "GRANDE OSPEDALE METROPOLITANO REGGIO CAL"
            },
            {
                "codiceConvenzione": "COMUNENISCEMI",
                "descrizioneConvenzione": "COMUNE DI NISCEMI"
            },
            {
                "codiceConvenzione": "COMUNEREGCALABR",
                "descrizioneConvenzione": "COMUNE DI REGGIO CALABRIA"
            },
            {
                "codiceConvenzione": "ARNAS CATANIA",
                "descrizioneConvenzione": "ARNAS CATANIA"
            },
            {
                "codiceConvenzione": "UNIVBASILICATA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DELLA BASILICATA"
            },
            {
                "codiceConvenzione": "ASLTARANTO",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE DI TARANTO"
            },
            {
                "codiceConvenzione": "UNISIENA",
                "descrizioneConvenzione": "UNIVERSIT\u00c0 DEGLI STUDI DI SIENA"
            },
            {
                "codiceConvenzione": "SMACAMPANIA",
                "descrizioneConvenzione": "SMA CAMPANIA"
            }
        ]
    },
    {
        "contrato": "cessione",
        "impiego": "privato",
        "convenzione": [
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "ENASARCO",
                "descrizioneConvenzione": "ENASARCO"
            },
            {
                "codiceConvenzione": "FERSERVIZI",
                "descrizioneConvenzione": "FERSERVIZI"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "CASSAFORENSE",
                "descrizioneConvenzione": "CASSA FORENSE"
            }
        ]
    },
    {
        "contrato": "delega",
        "impiego": "privato",
        "convenzione": [
            {
                "codiceConvenzione": "AZ OSP MESSINA",
                "descrizioneConvenzione": "AS. OSP MESSINA"
            },
            {
                "codiceConvenzione": "ASLFROSINONE",
                "descrizioneConvenzione": "AZIENDA UNITA' SANITARIA LOCALE FROSINONE"
            },
            {
                "codiceConvenzione": "COMUNEPATERNO'",
                "descrizioneConvenzione": "COMUNE DI PATERNO'"
            },
            {
                "codiceConvenzione": "CON_BON_ALTOJON",
                "descrizioneConvenzione": "CONSORZIO DI BONIFICA ALTO JONIO REGGINO"
            },
            {
                "codiceConvenzione": "ASST_NIGUARDA",
                "descrizioneConvenzione": "ASST GRANDE OSPEDALE METROPOL NIGUARDA"
            },
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "UNIVMESSINA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DI MESSINA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "CITTA_MESSINA",
                "descrizioneConvenzione": "CITTA' METROPOLITANA MESSINA"
            },
            {
                "codiceConvenzione": "COMUNEACIREALE",
                "descrizioneConvenzione": "COMUNE DI ACIREALE"
            },
            {
                "codiceConvenzione": "CITTA_PALERMO",
                "descrizioneConvenzione": "CITTA' METROPOLITANA PALERMO"
            },
            {
                "codiceConvenzione": "CITTA_NAPOLI",
                "descrizioneConvenzione": "CITTA' METROPOLITANA DI NAPOLI"
            },
            {
                "codiceConvenzione": "COMUNE BARI",
                "descrizioneConvenzione": "COMUNE DI BARI"
            },
            {
                "codiceConvenzione": "ASP_PALERMO",
                "descrizioneConvenzione": "AZIENDA SANITARIA PROVINCIALE PALERMO"
            },
            {
                "codiceConvenzione": "OSP_VILLASOFIA",
                "descrizioneConvenzione": "AZ. OSP. OSPEDALI RIUNITI VILLA SOFIA"
            },
            {
                "codiceConvenzione": "AOU SASSARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA SASSARI"
            },
            {
                "codiceConvenzione": "AZOSPSANCARLO",
                "descrizioneConvenzione": "AZIENDA OSPEDALERIA REGIONALE SAN CARLO"
            },
            {
                "codiceConvenzione": "SANITASERVICELE",
                "descrizioneConvenzione": "SANITASERVICE ASL LE SRL"
            },
            {
                "codiceConvenzione": "LAORE_SARDEGNA",
                "descrizioneConvenzione": "LAORE SARDEGNA"
            },
            {
                "codiceConvenzione": "COMUNEOLBIA",
                "descrizioneConvenzione": "COMUNE DI OLBIA"
            },
            {
                "codiceConvenzione": "REGIONESARDEGNA",
                "descrizioneConvenzione": "REGIONE AUTONOMA SARDEGNA"
            },
            {
                "codiceConvenzione": "AZ OSP CAGLIARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA DI CAGLIARI"
            },
            {
                "codiceConvenzione": "UNIVTORVERGATA",
                "descrizioneConvenzione": "UNIVERSITA' TOR VERGATA ROMA"
            },
            {
                "codiceConvenzione": "AZOSPBROTZU",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA BROTZU"
            },
            {
                "codiceConvenzione": "AGRIS_SARDEGNA",
                "descrizioneConvenzione": "AGRIS SARDEGNA"
            },
            {
                "codiceConvenzione": "AREUS SARDEGNA",
                "descrizioneConvenzione": "AREUS SARDEGNA"
            },
            {
                "codiceConvenzione": "ASLAVEZSULMAQU",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE AVEZZANO SULMONA L'AQUILA"
            },
            {
                "codiceConvenzione": "REGIONEVENETO",
                "descrizioneConvenzione": "REGIONE DEL VENETO"
            },
            {
                "codiceConvenzione": "UNI_CHIETIEPESC",
                "descrizioneConvenzione": "UNIVERSITA' CHIETI E PESCARA"
            },
            {
                "codiceConvenzione": "COMUNE_META",
                "descrizioneConvenzione": "COMUNE DI META"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "COMUNEMONTESARC",
                "descrizioneConvenzione": "COMUNE DI MONTESARCHIO"
            },
            {
                "codiceConvenzione": "GRANDEOSPMETROP",
                "descrizioneConvenzione": "GRANDE OSPEDALE METROPOLITANO REGGIO CAL"
            },
            {
                "codiceConvenzione": "COMUNENISCEMI",
                "descrizioneConvenzione": "COMUNE DI NISCEMI"
            },
            {
                "codiceConvenzione": "COMUNEREGCALABR",
                "descrizioneConvenzione": "COMUNE DI REGGIO CALABRIA"
            },
            {
                "codiceConvenzione": "ARNAS CATANIA",
                "descrizioneConvenzione": "ARNAS CATANIA"
            },
            {
                "codiceConvenzione": "UNIVBASILICATA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DELLA BASILICATA"
            },
            {
                "codiceConvenzione": "ASLTARANTO",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE DI TARANTO"
            },
            {
                "codiceConvenzione": "UNISIENA",
                "descrizioneConvenzione": "UNIVERSIT\u00c0 DEGLI STUDI DI SIENA"
            },
            {
                "codiceConvenzione": "SMACAMPANIA",
                "descrizioneConvenzione": "SMA CAMPANIA"
            }
        ]
    },
    {
        "contrato": "cessione",
        "impiego": "parapubblico",
        "convenzione": [
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "ENASARCO",
                "descrizioneConvenzione": "ENASARCO"
            },
            {
                "codiceConvenzione": "FERSERVIZI",
                "descrizioneConvenzione": "FERSERVIZI"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "CASSAFORENSE",
                "descrizioneConvenzione": "CASSA FORENSE"
            }
        ]
    },
    {
        "contrato": "delega",
        "impiego": "parapubblico",
        "convenzione": [
            {
                "codiceConvenzione": "RAP PALERMO",
                "descrizioneConvenzione": "RAP SPA"
            },
            {
                "codiceConvenzione": "AZ OSP MESSINA",
                "descrizioneConvenzione": "AS. OSP MESSINA"
            },
            {
                "codiceConvenzione": "ASLFROSINONE",
                "descrizioneConvenzione": "AZIENDA UNITA' SANITARIA LOCALE FROSINONE"
            },
            {
                "codiceConvenzione": "COMUNEPATERNO'",
                "descrizioneConvenzione": "COMUNE DI PATERNO'"
            },
            {
                "codiceConvenzione": "CON_BON_ALTOJON",
                "descrizioneConvenzione": "CONSORZIO DI BONIFICA ALTO JONIO REGGINO"
            },
            {
                "codiceConvenzione": "ASST_NIGUARDA",
                "descrizioneConvenzione": "ASST GRANDE OSPEDALE METROPOL NIGUARDA"
            },
            {
                "codiceConvenzione": "DUSMANN",
                "descrizioneConvenzione": "DUSMANN SPA"
            },
            {
                "codiceConvenzione": "UNIVMESSINA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DI MESSINA"
            },
            {
                "codiceConvenzione": "CASACURAABANOTE",
                "descrizioneConvenzione": "CASA DI CURA ABANO TERME"
            },
            {
                "codiceConvenzione": "CITTA_MESSINA",
                "descrizioneConvenzione": "CITTA' METROPOLITANA MESSINA"
            },
            {
                "codiceConvenzione": "COMUNEACIREALE",
                "descrizioneConvenzione": "COMUNE DI ACIREALE"
            },
            {
                "codiceConvenzione": "CITTA_PALERMO",
                "descrizioneConvenzione": "CITTA' METROPOLITANA PALERMO"
            },
            {
                "codiceConvenzione": "CITTA_NAPOLI",
                "descrizioneConvenzione": "CITTA' METROPOLITANA DI NAPOLI"
            },
            {
                "codiceConvenzione": "COMUNE BARI",
                "descrizioneConvenzione": "COMUNE DI BARI"
            },
            {
                "codiceConvenzione": "ASP_PALERMO",
                "descrizioneConvenzione": "AZIENDA SANITARIA PROVINCIALE PALERMO"
            },
            {
                "codiceConvenzione": "OSP_VILLASOFIA",
                "descrizioneConvenzione": "AZ. OSP. OSPEDALI RIUNITI VILLA SOFIA"
            },
            {
                "codiceConvenzione": "AOU SASSARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA SASSARI"
            },
            {
                "codiceConvenzione": "AZOSPSANCARLO",
                "descrizioneConvenzione": "AZIENDA OSPEDALERIA REGIONALE SAN CARLO"
            },
            {
                "codiceConvenzione": "SANITASERVICELE",
                "descrizioneConvenzione": "SANITASERVICE ASL LE SRL"
            },
            {
                "codiceConvenzione": "LAORE_SARDEGNA",
                "descrizioneConvenzione": "LAORE SARDEGNA"
            },
            {
                "codiceConvenzione": "COMUNEOLBIA",
                "descrizioneConvenzione": "COMUNE DI OLBIA"
            },
            {
                "codiceConvenzione": "REGIONESARDEGNA",
                "descrizioneConvenzione": "REGIONE AUTONOMA SARDEGNA"
            },
            {
                "codiceConvenzione": "AZ OSP CAGLIARI",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA UNIVERSITARIA DI CAGLIARI"
            },
            {
                "codiceConvenzione": "UNIVTORVERGATA",
                "descrizioneConvenzione": "UNIVERSITA' TOR VERGATA ROMA"
            },
            {
                "codiceConvenzione": "AZOSPBROTZU",
                "descrizioneConvenzione": "AZIENDA OSPEDALIERA BROTZU"
            },
            {
                "codiceConvenzione": "AGRIS_SARDEGNA",
                "descrizioneConvenzione": "AGRIS SARDEGNA"
            },
            {
                "codiceConvenzione": "AREUS SARDEGNA",
                "descrizioneConvenzione": "AREUS SARDEGNA"
            },
            {
                "codiceConvenzione": "ASLAVEZSULMAQU",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE AVEZZANO SULMONA L'AQUILA"
            },
            {
                "codiceConvenzione": "REGIONEVENETO",
                "descrizioneConvenzione": "REGIONE DEL VENETO"
            },
            {
                "codiceConvenzione": "UNI_CHIETIEPESC",
                "descrizioneConvenzione": "UNIVERSITA' CHIETI E PESCARA"
            },
            {
                "codiceConvenzione": "COMUNE_META",
                "descrizioneConvenzione": "COMUNE DI META"
            },
            {
                "codiceConvenzione": "POSTE",
                "descrizioneConvenzione": "POSTE ITALIANE"
            },
            {
                "codiceConvenzione": "COMUNEMONTESARC",
                "descrizioneConvenzione": "COMUNE DI MONTESARCHIO"
            },
            {
                "codiceConvenzione": "GRANDEOSPMETROP",
                "descrizioneConvenzione": "GRANDE OSPEDALE METROPOLITANO REGGIO CAL"
            },
            {
                "codiceConvenzione": "COMUNENISCEMI",
                "descrizioneConvenzione": "COMUNE DI NISCEMI"
            },
            {
                "codiceConvenzione": "COMUNEREGCALABR",
                "descrizioneConvenzione": "COMUNE DI REGGIO CALABRIA"
            },
            {
                "codiceConvenzione": "ARNAS CATANIA",
                "descrizioneConvenzione": "ARNAS CATANIA"
            },
            {
                "codiceConvenzione": "UNIVBASILICATA",
                "descrizioneConvenzione": "UNIVERSITA' DEGLI STUDI DELLA BASILICATA"
            },
            {
                "codiceConvenzione": "ASLTARANTO",
                "descrizioneConvenzione": "AZIENDA SANITARIA LOCALE DI TARANTO"
            },
            {
                "codiceConvenzione": "UNISIENA",
                "descrizioneConvenzione": "UNIVERSIT\u00c0 DEGLI STUDI DI SIENA"
            },
            {
                "codiceConvenzione": "SMACAMPANIA",
                "descrizioneConvenzione": "SMA CAMPANIA"
            }
        ]
    }
]